import { Chip } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import VerifiedIcon from "@mui/icons-material/Verified";
import SecurityIcon from "@mui/icons-material/Security";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ScheduleIcon from "@mui/icons-material/Schedule";
import GavelIcon from "@mui/icons-material/Gavel";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { DocumentType } from "../../common/redux/documentsAction";
import { useTranslation } from "react-i18next";

const labelConfig: Record<
    DocumentType,
    { color: "primary" | "default"; icon: JSX.Element }
> = {
    resume: { color: "primary", icon: <DescriptionIcon /> },
    diploma: { color: "primary", icon: <SchoolIcon /> },
    training_certificate: { color: "primary", icon: <WorkspacePremiumIcon /> },
    certifications: { color: "primary", icon: <VerifiedIcon /> },
    insurance: { color: "primary", icon: <SecurityIcon /> },
    invoice: { color: "primary", icon: <ReceiptIcon /> },
    quote: { color: "primary", icon: <AssignmentIcon /> },
    timetable: { color: "primary", icon: <ScheduleIcon /> },
    official_approval: { color: "primary", icon: <GavelIcon /> },
};

interface Props {
    label: DocumentType;
}

const LabelChip: React.FC<Props> = ({ label }) => {
    const { t } = useTranslation();
    const config = labelConfig[label];

    return (
        <Chip
            label={t(`documentsLabel.${label}`, { defaultValue: label })}
            icon={config.icon}
            color={config.color}
            size="small"
            sx={{
                fontSize: 10,
                textTransform: "capitalize",
                borderRadius: "5px",
            }}
        />
    );
};

export default LabelChip;
